






import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class ChannelIcon extends Vue {
	@Prop({required: true}) public channelType!: string;

	public get logo(): string {
		switch (this.channelType) {
			case 'sms-bt':
				return 'bt';
			case 'sms-govuknotify':
				return 'govuk-crown';
			case 'messenger':
				return 'fb-messenger';
			case 'twitter-dm':
				return 'twitter';
			case 'instagram':
				return 'instagram';
			case 'google-bm':
				return 'google-bm';
			default:
				return 'web-assistant';
		}
	}

	public get isWebAssistant() {
		return this.channelType === 'web-assistant';
	}
}
